/**
 * Historical Emporium - Accordion Component
 * Maneja la funcionalidad de acordeón para secciones he-accordion y he-customer-service
 */
class AccordionSection {
  constructor(section) {
    this.section = section;
    this.allowMultiple = section.dataset.allowMultiple === 'true';
    this.items = section.querySelectorAll('[data-accordion-item]');
    this.buttons = section.querySelectorAll('[data-accordion-button]');
    
    this.init();
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => this.handleClick(e));
    });
  }

  handleClick(e) {
    const button = e.currentTarget;
    const item = button.closest('[data-accordion-item]');
    const panel = item.querySelector('[data-accordion-panel]');
    const isOpen = item.classList.contains('he-accordion__item--open');

    if (!this.allowMultiple) {
      this.items.forEach((otherItem) => {
        if (otherItem !== item) {
          this.closeItem(otherItem);
        }
      });
    }

    if (isOpen) {
      this.closeItem(item);
    } else {
      this.openItem(item);
    }
  }

  openItem(item) {
    const button = item.querySelector('[data-accordion-button]');
    const panel = item.querySelector('[data-accordion-panel]');
    
    item.classList.add('he-accordion__item--open');
    button.setAttribute('aria-expanded', 'true');
    panel.style.display = 'block';
    panel.style.height = '0px';
    
    const targetHeight = panel.scrollHeight + 'px';
    panel.offsetHeight;
    
    requestAnimationFrame(() => {
      panel.style.height = targetHeight;
    });
    
    const handleTransitionEnd = () => {
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', handleTransitionEnd);
    };
    
    panel.addEventListener('transitionend', handleTransitionEnd);
  }

  closeItem(item) {
    if (!item.classList.contains('he-accordion__item--open')) {
      return;
    }

    const button = item.querySelector('[data-accordion-button]');
    const panel = item.querySelector('[data-accordion-panel]');
    
    const currentHeight = panel.scrollHeight + 'px';
    panel.style.height = currentHeight;
    panel.offsetHeight;
    
    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });
    
    panel.addEventListener('transitionend', function handler() {
      item.classList.remove('he-accordion__item--open');
      button.setAttribute('aria-expanded', 'false');
      panel.style.display = 'none';
      panel.style.height = '';
      panel.removeEventListener('transitionend', handler);
    });
  }
}

// Initialize all accordion sections
document.addEventListener('DOMContentLoaded', () => {
  const accordionSections = document.querySelectorAll('.he-accordion');
  accordionSections.forEach((section) => {
    new AccordionSection(section);
  });
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.he-accordion');
    if (section) {
      new AccordionSection(section);
    }
  });
}

